import script from "./NullWidget.vue?vue&type=script&lang=js"
export * from "./NullWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/containers/widget/components/NullWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c9ff7ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c9ff7ed', __exports__)) {
    api.reload('0c9ff7ed', __exports__)
  }
  
}


export default __exports__